import React from 'react';
import PropTypes from 'prop-types';
import Close from './Icons/Close';
import Code from './Icons/Code';
import Lock from './Icons/Lock';
import Mail from './Icons/Mail';
import Phone from './Icons/Phone';

const map = {
    close: Close,
    code: Code,
    lock: Lock,
    mail: Mail,
    phone: Phone,
};

const ImgIcon = props => {
    const {type} = props;
    const Icon = map[type];
    return <Icon />;
};


ImgIcon.propTypes = {
    type: PropTypes.string.isRequired,
};

export default ImgIcon;

